/* eslint-disable jsx-a11y/anchor-is-valid */

import LogicContext from "../../Context/LogicContext";
import { useCallback, useEffect, useRef } from "react";
import { useState } from "react";
import { useContext } from "react";
import { GetRewardHistoryStoreList, SetRewardHistoryStoreList } from "../../store/rewardHistoryAtom";

import RestartAlt from '@mui/icons-material/RestartAlt';
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useNavigate } from "react-router-dom";
import { rewardService } from '../../services/Reward.service';
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import RewardEarnTypeSelect from "./RewardEarnTypeSelect";
import { useForm } from "react-hook-form";
import moment from "moment";
import Papa from "papaparse";   // ← Added for reliable CSV export

const columns = [
  {
    title: 'Ref No',
    key: 'Ref_No',
    dataIndex: 'Ref_No',
    className: "text-primary",
    sorter: (a, b) => (a?.Ref_No ?? '') - (b?.Ref_No ?? '')
  },
  {
    title: "Customer",
    dataIndex: "Customer_Full_Name",
    sorter: (a, b) => (a?.Customer_Full_Name ?? '').localeCompare(b?.Customer_Full_Name ?? '')
  },
  {
    title: "Customer Address",
    dataIndex: "Customer_Email_Address",
    sorter: (a, b) => (a?.Customer_Email_Address ?? '').localeCompare(b?.Customer_Email_Address ?? '')
  },
  {
    title: "Mobile",
    dataIndex: "Customer_Mobile_No",
    sorter: (a, b) => (a?.Customer_Mobile_No ?? '').localeCompare(b?.Customer_Mobile_No ?? '')
  },
  {
    title: "Reward Quantity",
    dataIndex: "Reward_Cowries_Quantity",
    sorter: (a, b) => (a?.Reward_Cowries_Quantity ?? '') - (b?.Reward_Cowries_Quantity ?? '')
  },
  {
    title: "Trans. Date",
    dataIndex: "Transaction_Date",
    sorter: (a, b) => (a?.Transaction_Date ?? '').localeCompare(b?.Transaction_Date ?? ''),
    render: (record) => <span> {formatCustomDate(record)} </span>,
  },
];

function RewardEarnPage() {
  const logicContext = useContext(LogicContext);
  const getRecoilList = GetRewardHistoryStoreList();
  const setRecoilList = SetRewardHistoryStoreList();

  const [tableList, setTableList] = useState([]);
  const navigate = useNavigate();
  const mountedRef = useRef(true);

  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const [earnType, setEarnType] = useState(0);

  const { register, getValues } = useForm();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const new_list = queryParams.get('new_list');

  useEffect(() => {
    document.title = "Reward History ";
  }, []);

  useEffect(() => {
    if (getRecoilList.reward_info.length) {
      setTableList(getRecoilList.reward_info);
    } else {
      getRewardList();
    }
  }, [getRecoilList]);

  function getRewardList() {
    rewardService.getRewardHistory().then(response => {
      if (response?.data?.reward_info?.length) {
        setRecoilList(response?.data);
        setTableList(response?.data?.reward_info);
      }
    });
  }

  const searchByDate = async () => {
    const formData = getValues();
    const response = await rewardService.rewardByDate({ ...formData, earn_type_id: earnType });
    if (response?.data?.length) {
      setTableList(response.data);
    } else {
      setTableList([]);
      logicContext.showToast("No available record for your search query!", "");
    }
  };

  function handleRowClick(item) {
    const id = item['Ref_No'];
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
  }

  const onTypeSelect = (sel) => {
    setEarnType(sel?.Code);
  };

  // ====================== EXPORT CSV ======================
  const exportToCSV = () => {
    if (!tableList?.length) {
      logicContext.showToast("No data to export", "warning");
      return;
    }

    const headers = columns.map(col => col.title);
    const keys = columns.map(col => col.dataIndex);

    const dataForExport = tableList.map(row => {
      const obj = {};
      keys.forEach((key, i) => {
        let value = row[key] ?? '';

        // Apply same formatting as the table
        if (key === 'Transaction_Date') {
          value = formatCustomDate(value);
        }

        obj[headers[i]] = value;
      });
      return obj;
    });

    const csv = Papa.unparse(dataForExport, { header: true });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `reward_history_${moment().format("YYYY-MM-DD_HHmmss")}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    logicContext.showToast("✅ CSV exported successfully!", "success");
  };
  // =======================================================

  return (
    <>
      <section>
        <div className="w-full lg:flex justify-start">
          <section className="w-full">

            <section className="bg-white py-4 px-2 flex items-center justify-between gap-3">
              <div className="flex items-center gap-3 z-10">
                <Tooltip title="Reload">
                  <RestartAlt
                    className="cursor-pointer ml-2"
                    onClick={() => getRewardList()}
                    color="primary"
                    fontSize="large"
                  />
                </Tooltip>

                {/* Date Range Search */}
                <div className="flex items-center gap-3 z-10">
                  <div className="flex flex-col mb-3">
                    <label className="text-sm font-medium text-gray-700">From Date</label>
                    <input
                      defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                      {...register("from_date")}
                      type="date"
                      className="h-10 w-80 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    />
                  </div>
                  <div className="flex flex-col mb-3">
                    <label className="text-sm font-medium text-gray-700">To Date</label>
                    <input
                      defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                      {...register("to_date")}
                      type="date"
                      className="h-10 w-80 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    />
                  </div>
                  <RewardEarnTypeSelect
                    defaultValue={{ label: "All", journal_type_id: 0 }}
                    list={[{ Name: "All", journal_type_id: 0 }, ...getRecoilList.reward_type_info]}
                    onTypeSelect={onTypeSelect}
                    className="h-10 w-40"
                  />
                  <button
                    onClick={searchByDate}
                    type="button"
                    className="h-10 bg-blue-600 text-white text-sm font-medium rounded-md px-4 py-2 hover:bg-blue-700 transition-colors"
                  >
                    Search
                  </button>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <button
                  onClick={exportToCSV}
                  className="h-10 font-[Poppins] font-bold text-sm rounded-md px-4 py-2 bg-gray-200 hover:bg-gray-300 transition-colors"
                >
                  EXPORT
                </button>
              </div>
            </section>

            <section className="mt-5">
              <GeneralCustomTable
                tableHeadList={columns}
                tableDataList={tableList}
                allowCheckBox={false}
                rowKey={(record) => record.Ref_No}
                handleRowClick={handleRowClick}
              />
            </section>
          </section>
        </div>
      </section>
    </>
  );
}

export default RewardEarnPage;